// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"vendors-node_modules_notino_react-styleguide_dist_es_ActionButton_js-node_modules_notino_reac-23a55d":"c54ff0b2809e1351e1a4","AppLayout":"0eea2270a86ac2d2ff9c"}[chunkId] + ".chunk.js";
};